import { atom } from 'recoil'

export const pageState = atom({
  key: 'workflowStatistics__PageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    title: undefined
  }
})
